module.exports = __webpack_public_path__ + "img/pin-blue.9e3e882d.svg";